<script>
import { mapGetters, mapActions } from "vuex"
import _ from "underscore";
import { getCategoryList, getCagetoryTopicCount, buildRandomPaper,
    randomPaperInfo, 
 } from "../../utils/apis";
import common from "../../utils/common";
export default {
    data() {
        var checkTopicRandomRules = (rule, value, callback) => {
            let total = 0;
            let categoryArr = [];
            value.forEach((item) => {
                if (!item.category_id.length) {
                    callback(new Error("请选择试题分类"))
                    return
                }
                categoryArr.push(item.category_id.join("_"))
                item.list.forEach((val, index) => {
                    const temp = item.type_list.find((element) => Number(element.type) === Number(val.type))
                    console.log("temp", temp)
                    console.log("val", val)
                    if (Number(val.num) > 0 && !temp) {
                        callback(new Error(`该分类并没有${this.topicTypeLabel(val.type)}的题型`))
                        return
                    }
                    if (Number(val.num) > 0 && temp && Number(val.num) > temp.total) {
                        callback(new Error(`试题数量不能超过该分类下${this.topicTypeLabel(temp.type)}的总数`))
                        return
                    }
                    total += Number(val.num) + Number(val.score);
                    if ((!Number(val.num) && Number(val.score)) || (Number(val.num) && !Number(val.score))) {
                        callback(new Error("请同时设置试题数量与试题的分值"))
                        return
                    }
                })
            })
            if (total === 0) {
                callback(new Error("请设置试题数量和试题分值"))
                return 
            }
            if (isNaN(total)) callback(new Error("请设置合理的数值"));
            //分类是否重复检查
            const uniqueArr = [...new Set(categoryArr)]
            if (categoryArr.length !== uniqueArr.length) {
                callback(new Error("试题分类重复选择"));
            }
            callback();
        }
        return {
            id: this.$route.query.id ?? null,
            cascaderKey: 0,
            role: Number(localStorage.getItem("role")),
            randomForm: {
                paper_name: "",
                category_id: "",
                score: 0,
                topic_content: [
                    {
                        "category_id": "",
                        "list": [
                            {"type": 1, "num": "", "score": ""},
                            {"type": 2, "num": "", "score": ""},
                            {"type": 3, "num": "", "score": ""},
                            {"type": 4, "num": "", "score": ""},
                            {"type": 5, "num": "", "score": ""}
                        ],
                        type_list: [],
                    }
                ],
            },
            classProps: {
                value: 'rc_id',
                label: 'rc_name'
            },
            rules: {
                paper_name: [
                    { required: true, message: "试卷名称不能为空", trigger: "blur"},
                    { min: 3, max: 32, message: '试卷名称在3-32个字符之间', trigger: "blur"}
                ],
                category_id: [
                    { required: true, message: "试卷分类不能为空", trigger: "change"},
                ],
                topic_content: [
                    { required: true, message: "题型信息不能为空", trigger: 'blur'},
                    {validator: checkTopicRandomRules, trigger: 'blur'}
                ]
                
            }
        }
    },
    computed: {
        ...mapGetters(["getCourseId", "getCategoryList", "getRandomCategoryList"]),
        scoreVal() {
            let total = 0;
            if (this.randomForm.topic_content.length > 0) {
                this.randomForm.topic_content.forEach(item => {
                    item.list.forEach(val => {
                        total += Number(val.score) * Number(val.num)
                    })
                })
            }
            return total;
        }
    },
    mounted() {
        if (this.id) {
            this.detailData()
        }
        
    },
    watch: {
        getCategoryList(newVal) {
            this.cascaderKey++;
        }
    },
    methods: {
        ...mapActions([
            'updateCourseId'
        ]),
        detailData() {
            randomPaperInfo(this.id).then(({code, msg, data}) => {
                if (code === 200) {
                    this.randomForm.paper_name = data.paper_name
                    this.randomForm.category_id = data.category_id
                    this.randomForm.score = data.score
                    this.randomForm.topic_content = data.topic_content
                    console.log("data", data)
                    if (data.course_id) {
                        this.updateCourseId(data.course_id)
                    }
                } else {
                    this.$message.warning(msg)
                }
            })
        },
        topicTypeLabel(val) {
            const typeList = ["单选题", "多选题", "判断题", "填空题", "问答题"];
            return typeList[Number(val) - 1] ?? "";
        },
        objectSpanMerge({row, column, rowIndex, columnIndex}) {
            if (columnIndex === 0) {
                if (rowIndex % 5 === 0) {
                    return {
                        rowspan: 5,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
        },
        handleChange(value, index) {
            getCagetoryTopicCount({category_id: value[value.length - 1]}).then(({code, data, msg}) => {
                if (code === 200) {
                    this.randomForm.topic_content[index]["type_list"] = data
                }
            })
        },
        addTopicCategory() {
            this.randomForm.topic_content.push({
                        "category_id": "",
                        "list": [
                            {"type": 1, "num": "", "score": ""},
                            {"type": 2, "num": "", "score": ""},
                            {"type": 3, "num": "", "score": ""},
                            {"type": 4, "num": "", "score": ""},
                            {"type": 5, "num": "", "score": ""}
                        ],
                        type_list: [],
                    })
        },
        removeTopicCategory(index) {
            if (this.randomForm.topic_content.length === 1) {
                this.$message.warning("至少保留一个题型类型")
                return;
            }
            this.$confirm("删除之后无法撤回，确认删除？", "提示", {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.randomForm.topic_content.splice(index, 1);
                this.$refs.randomRef.validateField("topic_content")
            })
        },
        validateTopicContent() {
            this.$refs.randomRef.validateField("topic_content")
        },  
        cancelSubmit() {
            this.role === 3 ? this.$router.push({name: "teachIndex", params: {type: "paper"}}) : null;
        },
        submitData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.scoreVal !== 100) {
                        this.$message.warning("试卷的分值必须为100分")
                        return
                    }
                    const data = common.deepCopy(this.randomForm)
                    data.category_id = data.category_id[data.category_id.length - 1]
                    data.topic_content = data.topic_content.map((item) => {
                        item.category_id = item.category_id[item.category_id.length - 1]
                        return item;
                    })
                    data.score = this.scoreVal
                    data.course_id = this.getCourseId
                    if (this.id) {
                        data.id = this.id
                    }
                    buildRandomPaper(data).then(({code, msg, data}) => {
                        if (code === 200) {
                            this.$message({
                                type: "success",
                                duration: 1000,
                                message: msg,
                                onClose: () => this.cancelSubmit()
                            })
                        }

                    })
                    console.log("randomForm", data)
                }
            })
        },
    }
}
</script>
<template>
    <div class="random-container">
        <el-scrollbar style="height: 100%;">
            <div class="random-form-content">
                <el-form :model="randomForm" ref="randomRef" :rules="rules" label-position="top">
                    <el-form-item label="试卷名称" prop="paper_name">
                        <el-input  v-model="randomForm.paper_name" style="width: 300px;" placeholder="请输入内容"  />
                    </el-form-item>
                    <el-form-item label="试卷分类" prop="category_id">
                        <el-cascader
                            :key="cascaderKey"
                            style="width: 300px;"
                            v-model="randomForm.category_id"
                            :options="getCategoryList"
                            :props="classProps"
                            class="classes-list" clearable></el-cascader>

                    </el-form-item>
                    <el-form-item label="试卷分值">
                        <div class="score-content">
                            <span>{{ scoreVal }}</span>
                            <span>分</span>
                        </div>

                    </el-form-item>
                    <el-form-item prop="topic_content">
                        <div class="topic-category">
                            <div class="topic-label">
                                <div class="label">
                                    <span class="red">*</span>
                                    <span class="info">题型信息</span>
                                    <span class="desc">每个试题分类至少选择一种题型</span>
                                </div>
                                <div class="add-btn">
                                    <el-link icon="el-icon-plus" :underline="false" @click="addTopicCategory">新增试题分类</el-link>
                                </div>
                            </div>
                            <div class="topic-category-table-list">
                                <div class="topic-table" v-for="(item, key) in randomForm.topic_content" :key="key">
                                    <div class="remove-icon">
                                        <el-link :underline="false" icon="el-icon-delete" type="danger" @click="removeTopicCategory(key)"></el-link>
                                    </div>
                                    <el-table :data="item.list" border :span-method="objectSpanMerge">
                                        <el-table-column label="试题分类" width="250">
                                            <template slot-scope="scope">
                                                <div class="item-category-content">
                                                    <el-cascader
                                                        size="small"
                                                        :key="cascaderKey"
                                                        v-model="item.category_id"
                                                        :options="getRandomCategoryList"
                                                        :props="classProps"
                                                        @change="(value) => handleChange(value, key)"
                                                        class="classes-list" clearable></el-cascader>
                                                    <div class="category-topic-num">
                                                        <div class="label">该分类下共计：</div>
                                                        <div v-for="(type, typeIndex) in item.type_list" :key="typeIndex">
                                                            {{ topicTypeLabel(type.type) }}：共{{ type.total }}题
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="题型" align="center">
                                            <template slot-scope="scope">
                                                <span>{{ topicTypeLabel(scope.row.type) }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="试题数量">
                                            <template slot-scope="scope">
                                                <el-input size="small" v-model="scope.row.num" placeholder="请输入内容" @blur="validateTopicContent" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="每小题分值">
                                            <template slot-scope="scope">
                                                <el-input size="small" v-model="scope.row.score" @blur="validateTopicContent" placeholder="请输入内容" />
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </el-scrollbar>
        <div class="submit-content">
                <div class="btn-group">
                    <el-button class="w-150" type="primary" @click="submitData('randomRef')">确认</el-button>
                    <el-button class="w-150" @click="cancelSubmit">取消</el-button>
                </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.random-container {
    .w-150 {
        width: 150px;
    }
    position: relative;
    .submit-content {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &, & * {
        box-sizing: border-box;
    }
    width: 100%;
    height: 100%;
    padding-bottom: 40px;
    &:deep(.el-scrollbar) {
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

    }
    .random-form-content {
        width: 100%;
        height: 100%;
        padding-left: 20px;
        .score-content {
            width: 80px;
            height: 40px;
            border-radius: 5px;
            background-color: #F1F2F5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 10px 0 20px;
        }
    }
    .topic-category {
        width: 700px;
        .topic-label {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #000;
            .label {
                .red {
                    color: red;
                    margin-right: 8px;
                }
                .info {
                    font-size: 14px;
                    margin-right: 8px;
                }
                .desc {
                    font-size: 12px;
                    color: #B5B5B6;
                }
            }
        }
        .category-topic-num {
            height: 200px;
            padding: 15px;
            color: #B5B5B6;
        }
        .topic-category-table-list {
            .topic-table {
                margin-bottom: 10px;
                position: relative;
                .remove-icon {
                    position: absolute;
                    top: -10px;
                    right: -20px;
                }
            }

        }
    }
}
</style>